import { styled } from 'linaria/react';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  margin-top: 0;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: var(--space-50);
  margin-bottom: var(--space-50);

  @media screen and (max-width: 767px) {
    padding-bottom: var(--space-150);
    margin-top: 0;
    margin-bottom: var(--space-150);

    border-bottom: 1px dashed #e1e2e5;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: row;

  align-items: baseline;
  flex-wrap: nowrap;

  margin-right: var(--space-100);
  font-weight: normal;
  font-style: normal;
  color: var(--text-primary);

  &::after {
    display: block;
    flex: 1 1 0px;
    margin: 0 var(--space-100);
    border-bottom: 1px dashed #e1e2e5;
    content: '';

    @media screen and (max-width: 767px) {
      display: none;
    }
  }

  @media screen and (min-width: 1200px) {
    flex: 1 1 430px;

    font-size: 16px;
    line-height: 24px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1199px) {
    flex: 1 1 340px;

    font-size: 16px;
    line-height: 24px;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    flex: 1 1 324px;

    font-size: 16px;
    line-height: 24px;
  }
  @media screen and (max-width: 767px) {
    flex: 1 1 138px;

    font-size: 14px;
    line-height: 20px;
  }
`;

export const Value = styled.div`
  display: flex;
  flex-direction: row;
  margin-inline-start: unset;

  align-items: baseline;
  flex-wrap: nowrap;

  margin: 0;
  font-weight: normal;
  font-style: normal;
  color: var(--text-primary);

  @media screen and (min-width: 1200px) {
    flex: 1 1 430px;

    font-size: 16px;
    line-height: 24px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1199px) {
    flex: 1 1 340px;

    font-size: 16px;
    line-height: 24px;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    flex: 1 1 324px;

    font-size: 16px;
    line-height: 24px;
  }
  @media screen and (max-width: 767px) {
    justify-content: space-between;
    flex: 1 1 138px;

    font-size: 14px;
    line-height: 20px;
  }
`;
